import { useTheme } from "@mui/material";
import { createContext, ReactNode, useEffect, useState } from "react";

export type TDeviceContext = {
  isSmall: boolean;
  isMedium: boolean;
  isLarge: boolean;
  isExtraLarge: boolean;
  isPortraitMode: boolean;
};

const initialValue: TDeviceContext = {
  isSmall: false,
  isMedium: false,
  isLarge: false,
  isExtraLarge: false,
  isPortraitMode: false,
};

export const DeviceContext = createContext(initialValue);
DeviceContext.displayName = "DeviceContext";

export const DeviceProvider = ({ children }: { children: ReactNode }) => {
  const theme = useTheme();
  const small = `(max-width: ${theme?.breakpoints?.values?.sm || "600"}px)`;
  const medium = `(max-width: ${theme?.breakpoints?.values?.md || "980"}px)`;
  const large = `(min-width: ${theme?.breakpoints?.values?.md || "1200"}px)`;
  const extraLarge = `(min-width: ${
    theme?.breakpoints?.values?.lg || "1400"
  }px)`;
  const isPortrait = "(orientation: portrait)";

  const [isSmall, setSmall] = useState(false);
  const [isMedium, setMedium] = useState(false);
  const [isLarge, setLarge] = useState(false);
  const [isExtraLarge, setExtraLarge] = useState(false);
  const [isPortraitMode, setPortraitMode] = useState(false);

  useEffect(() => {
    const mqs = window.matchMedia(small);
    const mqm =
      window.matchMedia(medium).matches && !window.matchMedia(small).matches;
    const mql = window.matchMedia(large);
    const mqXl = window.matchMedia(extraLarge);
    const mqPortrait = window.matchMedia(isPortrait);

    const onChange = () => {
      setSmall(mqs.matches);
      setMedium(mqm);
      setLarge(mql.matches);
      setExtraLarge(mqXl.matches);
      setPortraitMode(mqPortrait.matches);
    };

    onChange();

    window.addEventListener("resize", onChange);

    return () => {
      window.removeEventListener("resize", onChange);
    };
  }, [extraLarge, large, medium, small]);

  return (
    <DeviceContext.Provider
      value={{
        isSmall,
        isMedium,
        isLarge,
        isExtraLarge,
        isPortraitMode,
      }}
    >
      {children}
    </DeviceContext.Provider>
  );
};
